import React, {Component} from 'react';
import {Card, Button, Header, Form, Grid} from 'semantic-ui-react';
import MapSearchBox from '../extras/MapSearchBox';
import update from 'react-addons-update';
import StoreData from "../../data/StoreData";

import Toast from "../extras/Toast";
import resources from "../../data/resources";
import LocalData from "../../data/LocalData";

class AboutStore extends Component {
    constructor() {
        super();

        this.state = {
            display: 'block',
            store: {
                nit: '',
                phone: '',
                address: '',
                profile: {
                    email: ""
                },
                latLng: {lat: null, lng: null}
            },
            nit_error: false,
            phone_error: false,
            address_error: false,
            email_error: false,
            loading: false,
        };

        this.next = this.next.bind(this);
        this.open = this.open.bind(this);
        this.handleNitChange = this.handleNitChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.getMarkers = this.getMarkers.bind(this);
    }

    handleNitChange(event) {
        let data = update(this.state, {
            store: {
                nit: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({nit_error: true});
        } else {
            this.setState({nit_error: false});
        }
    };

    handleEmailChange(event) {
        let data = update(this.state, {
            store: {
                profile: {
                    email: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '' || !resources.validators.isValidEmailAddress(event.target.value) ) {
            this.setState({email_error: true});
        } else {
            this.setState({email_error: false});
        }
    };

    handlePhoneChange(event) {
        let data = update(this.state, {
            store: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({phone_error: true});
        } else {
            this.setState({phone_error: false});
        }
    };

    handleAddressChange(event) {
        let data = update(this.state, {
            store: {
                address: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({address_error: true});
        } else {
            this.setState({address_error: false});
        }
    };

    next() {
        if (this.state.store.nit === '') {
            this.setState({nit_error: true})
        } else if (this.state.store.phone === '') {
            this.setState({phone_error: true})
        } else if (this.state.store.address === '') {
            this.setState({address_error: true})
        } else if (this.state.store.profile.email === '' || !resources.validators.isValidEmailAddress(this.state.store.profile.email)) {
            this.setState({email_error: true})
        } else if (this.state.store.latLng.lat === null) {
            this.refs.toast.show({message: 'Por favor ubica tu negocio en el mapa!', type: 'error'});
        } else {
            this.setState({loading: true});
            StoreData.setup(this.state.store, (res) => {
                LocalData.products();
                if (res.update) {
                    this.setState({display: 'none'});
                    this.props.finish();
                } else {
                    this.refs.toast.show({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                }
                this.setState({loading: false});
            });
        }
    }

    getMarkers(markers) {
        let data = update(this.state, {
            store: {
                latLng: {
                    $set: markers
                }
            }
        });
        this.setState(data);
    }


    open() {
        this.setState({display: 'block'});
    }

    render() {
        return (
            <Card fluid style={{display: this.state.display}}>
                <Header as='h1' textAlign='center' style={{'marginTop': 10, 'paddingTop': 10}}>
                    Cuentános un poco sobre tu negocio
                </Header>
                <Card.Content>
                    <Form>
                        <Grid stackable>
                            <Grid.Row>
                                <Grid.Column width={6}>
                                    <Form.Input label='NIT o Identificación' placeholder='NIT o Identificación'
                                                value={this.state.store.nit} onChange={this.handleNitChange}
                                                error={this.state.nit_error}/>
                                    <Form.Input label='Teléfono' placeholder='Teléfono' value={this.state.store.phone}
                                                onChange={this.handlePhoneChange} error={this.state.phone_error}/>
                                    <Form.Input label='Dirección' placeholder='Dirección'
                                                value={this.state.store.address} onChange={this.handleAddressChange}
                                                error={this.state.address_error}/>
                                    <Form.Input label='Email'
                                                   placeholder='Email'
                                                   value={this.state.store.profile.email}
                                                   onChange={this.handleEmailChange}
                                                   error={this.state.email_error}/>
                                </Grid.Column>
                                <Grid.Column width={10}>
                                    <Form.Field>
                                        <label>Ubicación</label>
                                        <MapSearchBox callbackMarkers={this.getMarkers} latitude={0} longitude={0}/>
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </Card.Content>
                <Card.Content extra>
                    <Button primary floated='right' onClick={() => this.next()} disabled={this.state.loading}
                            loading={this.state.loading}>
                        Finalizar
                    </Button>
                </Card.Content>
                <Toast ref='toast' />
            </Card>
        );
    }
}

export default AboutStore;



// WEBPACK FOOTER //
// ./src/components/setup/AboutStore.js